import { z } from 'zod';

import { ForgotPasswordFormFields, ForgotPasswordFormValues } from '../types';

const emailValidationSchema = z.email({ message: 'Format is incorrect' });

export const forgotPasswordValidationSchema = z.object({
  [ForgotPasswordFormFields.email]: emailValidationSchema,
}) satisfies z.ZodType<ForgotPasswordFormValues>;
